import { createFeature, createReducer, on } from '@ngrx/store'
import { JobState } from './job.state'
import { jobActions } from './job.actions'
import { caseActions } from '../case/case.actions'

const createInitialState = (): JobState => ({
    jobs: [],
})

export const jobFeature = createFeature({
    name: 'job',
    reducer: createReducer<JobState>(
        createInitialState(),
        on(jobActions.loadingJobsSucceeded, (state, action): JobState => {
            return {
                ...state,
                jobs: action.jobs,
            }
        }),
        on(caseActions.selectCase, (): JobState => createInitialState())
    ),
})

export const { reducer } = jobFeature
